import React, { useEffect, useState } from 'react';
import Layout from '../../../components/common/pageLayout';
import { v3_createNewBuildingPreDeliveryCheckListFields, v3_fetchNewBuildingPreDeliveryCheckListFields } from '../../../actions/v3/productionForm';
import { toast } from 'react-toastify';
import constant from '../../../constant';
import { ConfigMeta, findEmptySection, toastSaveResult } from '../../../components/Production/Configure/configMeta';
import FormBuilder from '../../../components/Production/Configure/NewBuildingPreDeliveryCheckList'

const NewBuildingPreDeliveryCheckList = (props) => {


    const [state, setState] = useState([]);

    const [showLoader, setShowLoader] = useState(false);
    // Config is global and shared; keep the version we loaded so the API can reject
    // a save made on top of someone else's newer one, and collect hard-delete ids.
    const [configMeta, setConfigMeta] = useState(null);
    const [configVersion, setConfigVersion] = useState('');
    const [deletedIds, setDeletedIds] = useState([]);
    useEffect(() => {
        setShowLoader(true);
        v3_fetchNewBuildingPreDeliveryCheckListFields()
            .then((res) => {
                if (res.status) {
                    setConfigMeta(res.result.configMeta || null);
                    setConfigVersion(res.result.configMeta?.version || '');
                    setState(res.result.sections && res.result.sections.length > 0 ? res.result.sections : [
                        {
                            id: '',
                            name: '',
                            active: true,
                            items: [{ id: '', label: '', active: true }]
                        }
                    ]);


                } else {
                    toast.error(res.error);
                }
            })
            .catch((error) => {
                console.error('Fetch error:', error);
                toast.error('Something went wrong while fetching.');
            })
            .finally(() => {
                setShowLoader(false);
            });
    }, []);

    const onSubmit = () => {
        const emptySection = findEmptySection(state);
        if (emptySection) {
            toast.error(`Section "${emptySection.name || '(unnamed)'}" needs at least one item with a label before it can be saved.`);
            return;
        }
        setShowLoader(true)
        const payload = {
            configVersion,
            deletedIds,
            data: state.map(section => ({
                id: section.id,
                name: section.name,
                active: section.active,
                items: section.items.map(item => ({
                    id: item.id,
                    label: item.label,
                    active: item.active,
                })),
            })),
        };

        v3_createNewBuildingPreDeliveryCheckListFields(payload)
            .then((res) => {
                if (res.status) {
                    toastSaveResult(res.result);
                    props.history.push(constant.Authedcomponent.production.url)
                } else {
                    toast.error(res.error);
                }
            })
            .catch((error) => {
                console.error('Submission error:', error);
                toast.error('Something went wrong while submitting.');
            })
            .finally(() => {
                setShowLoader(false);
            });
    };

    return (
        <Layout title={'New Building Pre Delivery Check List'}>
            <div className="row">
                <div className="col-lg-12">
                    <div className="card" id={1}>
                        <div className="card-body">
                            <div className="checklist-title-bx">
                                <div className="row">
                                    <div className="col-md-8">
                                        <div className="text-left">
                                            <h4>New Building Pre Delivery Check List</h4>
                                            <p>
                                                Following to be checked and confirmed before official delivery
                                                of the vessel
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-4 text-md-end">
                                        {/* This config is global - one shared item list per form, not per project/hull. */}
                                        <ConfigMeta meta={configMeta} />
                                    </div>
                                </div>
                            </div>
                            <FormBuilder
                                state={state}
                                setState={setState}
                                onSubmit={() => { onSubmit() }}
                                onDeleteSavedItem={(id) => setDeletedIds((prev) => [...prev, id])}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};


export default NewBuildingPreDeliveryCheckList


